const initYieldPrograms = () => {
	const sections = document.querySelectorAll( 'section.yield-programs' );

	if ( sections.length ) {
		Array.from( sections ).forEach( ( section ) => {
            if ( !section ) {
                return;
            }
			const isEn = document.querySelector( 'body' ).classList.contains( 'en' );

			const selectedItem = section.querySelector( 'div.selected' );
			const menu = section.querySelector( 'div.select > ul' );

			let personal;
			let guaranteed;
			let fiveYearsGuaranteed;

			const personalSelectedItem = section.querySelector( '.personal div.selected' );
			const personalMenu = section.querySelector( '.personal div.select > ul' );
			const personalOutput = section.querySelector( '.personal div.result > .output' );

			const guaranteedSelectedItem = section.querySelector( '.guaranteed div.selected' );
			const guaranteedMenu = section.querySelector( '.guaranteed div.select > ul' );
			const yearGuaranteedOutput = section.querySelector( '.guaranteed div.result .year > .output' );
			const fiveYearsGuaranteedOutput = section.querySelector( '.guaranteed div.result .five-years > .output' );

			const input = section.querySelector( '.input-calculator input' );
			const yearIncomeOutput = section.querySelector( '.input-calculator .result .year .output' );
			const fiveyearsIncomeOutput = section.querySelector( '.input-calculator .result .five-years .output' );
			
			if ( personalMenu ) {
				personal = JSON.parse(section.querySelector( 'div.personal' ).getAttribute( 'data-personal' ));
				guaranteed = JSON.parse(section.querySelector( 'div.guaranteed' ).getAttribute( 'data-guaranteed' ));
				fiveYearsGuaranteed = JSON.parse(section.querySelector( 'div.guaranteed' ).getAttribute( 'data-fiveyears-guaranteed' ));
			}

			document.addEventListener( 'click', function(e) {
				if ( window.innerWidth < 768 && !e.target.closest( 'div.select' ) ) {
					selectedItem.parentNode.classList.remove( 'active' );
				}
			})

			if ( selectedItem ) {
				selectedItem.addEventListener( 'click', () => {
					selectedItem.parentNode.classList.toggle( 'active' );
				})

				for ( let menuItem of menu.childNodes ) {
					menuItem.addEventListener( 'click', () => {
						selectedItem.parentNode.classList.remove( 'active' );
						selectedItem.innerText = menuItem.innerText;
					})
				}				
			}

			if ( personalSelectedItem ) {
				personalSelectedItem.addEventListener( 'click', () => {
					personalSelectedItem.parentNode.classList.toggle( 'active' );
				})

				for ( let menuItem of personalMenu.childNodes ) {
					menuItem.addEventListener( 'click', () => {
						personalMenu.childNodes.forEach( item => item.classList.remove( 'active' ));
						menuItem.classList.add( 'active' );
						personalOutput.innerHTML = personal[+menuItem.getAttribute( 'data-id' )] + '&thinsp;&#3647;';
						personalSelectedItem.parentNode.classList.remove( 'active' );
						personalSelectedItem.innerText = menuItem.innerText;
					})
				}				
			}

			if ( guaranteedSelectedItem ) {
				yearGuaranteedOutput.innerHTML = guaranteed[0] + '&thinsp;&#3647;';
				fiveYearsGuaranteedOutput.innerHTML  = fiveYearsGuaranteed[0] + '&thinsp;&#3647;';
				
				guaranteedSelectedItem.addEventListener( 'click', () => {
					guaranteedSelectedItem.parentNode.classList.toggle( 'active' );
				})

				for ( let menuItem of guaranteedMenu.childNodes ) {
					menuItem.addEventListener( 'click', () => {
						guaranteedMenu.childNodes.forEach( item => item.classList.remove( 'active' ));
						menuItem.classList.add( 'active' );
						yearGuaranteedOutput.innerHTML = guaranteed[+menuItem.getAttribute( 'data-id' )] + '&thinsp;&#3647;';
						fiveYearsGuaranteedOutput.innerHTML = fiveYearsGuaranteed[+menuItem.getAttribute( 'data-id' )] + '&thinsp;&#3647;';
						guaranteedSelectedItem.parentNode.classList.remove( 'active' );
						guaranteedSelectedItem.innerText = menuItem.innerText;
					})
				}				
			}
			
			if ( input ) {
				input.addEventListener('input', () => {
					yearIncomeOutput.innerHTML = new Intl.NumberFormat('RU-ru', { maximumSignificantDigits: 3 }).format(Math.round( input.value * 0.07 )) + '&thinsp;&#3647;';
					fiveyearsIncomeOutput.innerHTML = new Intl.NumberFormat('RU-ru', { maximumSignificantDigits: 3 }).format(Math.round( input.value * 0.07 * 5 )) + '&thinsp;&#3647;';
				})
			}

			const personalContol = section.querySelector( '.personal-control' );

			if ( personalContol ) {

				const data = JSON.parse(personalContol.getAttribute( 'data' ));
				const dataDictionary = JSON.parse(personalContol.getAttribute( 'data-dictionary' ));

				const selectList = personalContol.querySelector( '.projects ul' );
				const personalControlSelectedItem = personalContol.querySelector( '.projects div.selected' );

				const selectListRooms = personalContol.querySelector( '.apartments ul' );
				const personalControlSelectedRoomsItem = personalContol.querySelector( '.apartments div.selected' );

				const output = personalContol.querySelector( '.result .output' );

				const keys = Object.keys(data);

				document.addEventListener( 'click', function(e) {
					if ( !e.target.closest( '.projects' ) ) {
						selectedItem.parentNode.classList.remove( 'active' );
					}
					if ( !e.target.closest( '.apartments' ) ) {
						selectListRooms.parentNode.classList.remove( 'active' );
					}
					
				})

				let selectedBuilding = keys[0];
				let selectedApartment;

				const initNewApartmentsList = () => {
					const selectListRooms = personalContol.querySelector( '.apartments ul' );
					for ( let menuItem of selectListRooms.childNodes ) {
						menuItem.addEventListener( 'click', () => {
							selectListRooms.childNodes.forEach( item => item.classList.remove( 'active' ));
							menuItem.classList.add( 'active' );
							personalControlSelectedRoomsItem.parentNode.classList.remove( 'active' );
							personalControlSelectedRoomsItem.innerText = menuItem.innerText;
							selectedApartment = menuItem.getAttribute( 'data-apartament' );
							changeOutput();
						})
					}
				}

				const changeApartmentsList = (project) => {
					selectListRooms.innerHTML = project.map( (item, index) => {
						if (index === 0) personalControlSelectedRoomsItem.innerText = isEn ? dataDictionary[item].en : dataDictionary[item].ru;
						return `<li data-apartament='${item}' ${index === 0 ? 'class="active"' : ''}> ${isEn ? dataDictionary[item].en : dataDictionary[item].ru } </li>`
					} ).join('');
					initNewApartmentsList();
				}

				changeApartmentsList(Object.keys(data[selectedBuilding]));

				const changeOutput = () => {
					output.innerHTML = new Intl.NumberFormat('RU-ru', { maximumSignificantDigits: 3 }).format(data[selectedBuilding][selectedApartment]) + '&thinsp;&#3647;';
				}

				selectList.innerHTML = keys.map( (item, index) => {
					return `<li ${index === 0 ? 'class="active"' : ''} data-complex='${item}'>${item.replace( '_', ' ' )}</li>`;
				} ).join( '' );

				personalControlSelectedItem.innerText = keys[0].replace( '_', ' ' );

				for ( let menuItem of selectList.childNodes ) {
					menuItem.addEventListener( 'click', () => {
						selectList.childNodes.forEach( item => item.classList.remove( 'active' ));
						menuItem.classList.add( 'active' );
						personalControlSelectedItem.parentNode.classList.remove( 'active' );
						personalControlSelectedItem.innerText = menuItem.innerText;
						selectedBuilding = menuItem.getAttribute( 'data-complex' );
						changeApartmentsList(Object.keys(data[selectedBuilding]));
						selectedApartment = Object.keys(data[selectedBuilding])[0];
						changeOutput();
					})
				}
				
				personalControlSelectedRoomsItem.addEventListener( 'click', () => {
					personalControlSelectedRoomsItem.parentNode.classList.toggle( 'active' );
				})
			}
		}) 
	}
}

export {
	initYieldPrograms,
};